import { makeStyles, fade } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  dialogXS: {
    '& .MuiDialog-scrollPaper': {
      alignItems: 'flex-end',
    },
    '& .MuiDialog-paperFullWidth': {
      width: '100%',
      margin: 0,
    },
    '& .MuiPaper-rounded': {
      borderRadius: theme.spacing(1, 1, 0, 0),
    },
    '& .MuiDialogContent-dividers': {
      borderBottom: 'none',
    },
    '& .MuiDialog-paperFullScreen': {
      borderRadius: 0,
    },
  },
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1, 2, 1, 4),
    backgroundColor: theme.palette.primary.lighter,
    '& .MuiTypography-root': {
      fontWeight: 600,
    },
  },
  dialogClose: {
    color: theme.palette.primary.dark,
  },
  dialogContent: {
    margin: 0,
    padding: theme.spacing(4, 2),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(4),
    },
  },
  form: {
    width: '100%', // Fix IE 11 issue.
  },
  formControl: {
    margin: theme.spacing(0, 0, 3),
  },
  textConfirmed: {
    color: theme.palette.primary.light,
  },
  successIcon: {
    fill: theme.palette.primary.light,
  },
  alert: {
    margin: theme.spacing(0, -2, 3),
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(0, -4, 3),
    },
  },
  submit: {
    marginTop: theme.spacing(1),
  },
  hasValue: {
    '& .MuiInputBase-root': {
      color: theme.palette.primary.light,
      borderColor: fade(theme.palette.primary.main, 0.16),
      backgroundColor: theme.palette.primary.lighter,
    },
  },
}))

export default useStyles
